module.exports = __webpack_public_path__ + "img/10.dce67bf3.png";